import { DateRangePicker } from "$components/inputs";
import { Box, styled } from "@material-ui/core";
import { addMonths, format, parseISO } from "date-fns";
import React from "react";
import { DATE_FORMAT } from "./constants";

const Container = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(),
  display: "flex",
  alignItems: "center",
  fontSize: "16px",
}));

export const DownloadDateFilters = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
}: {
  startDate: string;
  endDate: string;
  setStartDate: React.Dispatch<React.SetStateAction<string>>;
  setEndDate: React.Dispatch<React.SetStateAction<string>>;
}) => {
  return (
    <Container>
      <DateRangePicker
        hideHelper
        fromValue={startDate}
        setFromValue={(v) => {
          const updatedStartDate = v ? new Date(v) : new Date();
          const monthAfterStartDate = addMonths(updatedStartDate, 1);
          const shouldSnapEndDate =
            endDate && parseISO(endDate) > monthAfterStartDate;
          if (shouldSnapEndDate) {
            setEndDate(format(monthAfterStartDate, DATE_FORMAT));
          }
          setStartDate(format(updatedStartDate, DATE_FORMAT));
        }}
        toValue={endDate}
        setToValue={(v) => {
          const updatedEndDate = v ? new Date(v) : new Date();
          const monthBeforeEndDate = addMonths(updatedEndDate, -1);
          const shouldSnapStartDate =
            startDate && parseISO(startDate) < monthBeforeEndDate;
          if (shouldSnapStartDate) {
            setStartDate(format(monthBeforeEndDate, DATE_FORMAT));
          }
          setEndDate(format(updatedEndDate, DATE_FORMAT));
        }}
      />
    </Container>
  );
};
